import { TabContentTranslations } from ".";

export const TAB_CONTENT_FR_FR: TabContentTranslations = {
	consolidated: "Compétence",
	extract: "Extrait",
	revenueSettlement: "Règlement de Caisse",
	pendingTransactions: "Transactions en Attente",
	new: "NOUVEAU",
	consolidatedTooltip:
		"Indique la période au cours de laquelle la vente ou l'opération a été réalisée, quelle que soit la date de paiement.",
	revenueSettlementTooltip:
		"Indique la période au cours de laquelle les montants ont été effectivement payés ou reçus.",
	pendingTransactionsTooltip:
		"Liste des transactions en cours d'évaluation par l'équipe Zig, non encore enregistrées dans le relevé.",
};
